'use strict';

export default () => {
  'ngInject';

  return (number) => {
    number = number * 1;
    if (number < 10) {
      number = '<10';
    } else if (number > 9 && number < 100) {
      number = '10+';
    } else if (number > 99 && number < 999) {
      number = Math.floor(number / 100) * 100 + '+';
    } else if (number > 999) {
      number = Math.floor(number / 1000) + 'k+';
    }
    return number;
  };
};



// WEBPACK FOOTER //
// ./app/src/filters/round.filter.js